import React from 'react';
import { SectionHeading } from './SectionHeading';
import { Reveal } from './Reveal';
import { CtaButton } from './CtaButton';
import { bonuses, site } from '../data/landing';
const paymentMethods = [{
  emoji: '📱',
  label: 'Pago Móvil',
  sub: 'Tasa BCV oficial',
  highlight: true
}, {
  emoji: '💳',
  label: 'Tarjeta',
  sub: 'Visa / Mastercard',
  highlight: false
}, {
  emoji: '₿',
  label: 'Binance Pay',
  sub: 'USDT / BTC',
  highlight: false
}];
export function BonusesSection() {
  return <section id="bonos" className="bg-gradient-to-br from-primary to-primary-dark py-16 text-white sm:py-24" data-id="element-11" data-mp="zv13d1rwrk0r">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-12" data-mp="1ejnjh5pd0ft1">
        <SectionHeading tone="dark" title={<>
              Además incluye <span className="text-success-light" data-id="element-14" data-mp="19mnbuqcv34zt">3 BONOS GRATIS</span> valorados en $47
            </>} data-id="element-13" data-mp="1el8d8t3unupu" />
        <ul className="mt-10 grid gap-4 md:grid-cols-3 md:gap-6" data-id="element-15" data-mp="1jiqpasd5yq22">
          {bonuses.map((bonus, i) => <Reveal as="li" key={bonus.label} delay={i * 0.05} className="h-full" data-id="element-16" data-mp="3pqttoki7txeu" data-mpi={i}>
              <div className="flex h-full flex-col rounded-2xl border border-white/15 bg-white/10 p-6" data-id="element-17" data-mp="3trx770csjhcw">
                <div className="flex items-center justify-between" data-id="element-18" data-mp="2lvtek1fy9nk">
                  <span className="rounded-md bg-white px-2 py-1 text-xs font-extrabold text-primary" data-id="element-19" data-mp="2np5wfyqjo3h">{bonus.label}</span>
                  <span className="text-sm font-semibold text-blue-100" data-id="element-20" data-mp="cjs7nkpodkpw">{bonus.value} valor</span>
                </div>
                <h3 className="mt-5 text-xl font-extrabold leading-snug" data-id="element-21" data-mp="gkvn463t9eql">
                  <span aria-hidden="true" data-id="element-22" data-mp="lc3s8py3ydxy">{bonus.emoji} </span>
                  {bonus.title}
                </h3>
                <p className="mt-2 text-[15px] leading-relaxed text-blue-100" data-id="element-23" data-mp="qbq6n2poa08c">{bonus.description}</p>
                <p className="mt-auto pt-5 text-sm font-bold text-success-light" data-id="element-24" data-mp="vatd8rlaweif">GRATIS con tu compra</p>
              </div>
            </Reveal>)}
        </ul>

        <Reveal className="mt-12 flex flex-col items-center text-center" data-id="element-25" data-mp="107091rjzg9mn">
          <p className="text-sm font-semibold text-blue-100" data-id="element-26" data-mp="alquyscwi022">Valor total de todo lo que recibes</p>
          <p className="mt-2 flex items-baseline gap-3" data-id="element-27" data-mp="5np77u4j5ck9">
            <span className="text-2xl font-bold text-blue-200 line-through decoration-red-400 decoration-[3px] sm:text-3xl" data-id="element-28" data-mp="kbk0bbmg9ixv">$71.99</span>
            <span aria-hidden="true" className="text-2xl text-blue-200" data-id="element-29" data-mp="fir1139r32t6">→</span>
            <span className="text-4xl font-black sm:text-5xl" data-id="element-30" data-mp="tap34u51nyfu">Solo {site.price}</span>
          </p>
          <CtaButton className="mt-8" data-id="element-31" data-mp="oblxb7h8po6t">Quiero mi Cotizador PRO — {site.price}</CtaButton>

          {/* Métodos de pago */}
          <div className="mt-6 w-full max-w-md rounded-xl bg-white/10 px-4 py-4" data-id="element-32" data-mp="1394tuw05t5ot">
            <p className="mb-3 text-xs font-semibold uppercase tracking-widest text-white/60" data-id="element-33" data-mp="yc4l2dbxdou0">Formas de pago</p>
            <div className="flex flex-wrap justify-center gap-2" data-id="element-34" data-mp="351sx35cszt4l">
              {paymentMethods.map(m => <div key={m.label} className={`flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-semibold ${m.highlight ? 'bg-success-light text-ink ring-2 ring-success-light' : 'bg-white/10 text-white'}`} data-id="element-35" data-mp="3049b1j9v6c23">
                  <span aria-hidden="true" data-id="element-36" data-mp="1asnh5egfrl37">{m.emoji}</span>
                  <span data-id="element-37" data-mp="1ar2pbwliag91">
                    {m.label}
                    <span className={`ml-1 text-xs font-normal ${m.highlight ? 'text-ink/60' : 'text-white/60'}`} data-id="element-38" data-mp="wsuw9zrlbz35">{m.sub}</span>
                  </span>
                </div>)}
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}